<template>
  <section id="landing-steps">
    <header class="landing-default">
      <h3>Jak wynająć adres w wirtualnym biurze?</h3>
    </header>
    <div class="flex">
      <router-link to="/pakiety" title="Przejdź do wyboru pakietu">
       <div class="step">
        <div class="number">
          <div class="circle">
            <p>1</p>
          </div>
        </div>
        <h6>Wybierz pakiet</h6>
      </div>
      </router-link>
      <div class="step-line"></div>
      <div class="step">
          <div class="number">
          <div class="circle">
            <p>2</p>
          </div>
        </div>
        <h6>Wypełnij formularz</h6>
      </div>
      <div class="step-line"></div>
      <div class="step">
          <div class="number">
          <div class="circle">
            <p>3</p>
          </div>
        </div>
        <h6>Opłać abonament</h6>
      </div>
      <div class="step-line"></div>
      <div class="step">
          <div class="number">
          <div class="circle">
            <p>4</p>
          </div>
        </div>
        <h6>Korzystaj z biura</h6>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LandingSteps',
}
</script>

<style scoped lang="scss">
  section#landing-steps { margin-bottom: 50px; }
  section#landing-steps header { margin: 50px 15px 50px 15px; }
  section#landing-steps div.flex { display: flex; justify-content: center; }
  a:hover div.step div.number div.circle { background: $orangeDark;  }
  a:hover div.step div.number div.circle p { color: #fff; }

  @media (max-width: 850px) {
    section#landing-steps div.flex { flex-wrap: wrap; }
  }
</style>
